import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      position="top-right"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-[#1e1e2d] text-white border-[#2a2a3d] shadow-lg",
          description: "text-gray-400",
          actionButton:
            "bg-blue-600 text-white",
          cancelButton:
            "bg-[#2a2a3d] text-gray-400",
          success: "border-green-500/30",
          error: "border-red-500/30",
          warning: "border-yellow-500/30",
          info: "border-blue-500/30",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
